var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.targetTile)?_c('div',[_c('h1',{staticClass:"detailTitle"},[_vm._v(_vm._s(_vm.targetTile.name))]),_vm._v(" "),_c('img',{staticClass:"detailImg",attrs:{"src":_vm.targetTile.fotoURL,"width":"30%"}}),_vm._v(" "),_c('p',{staticClass:"detailText"},[_vm._v(_vm._s(_vm.targetTile.text))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-609dad4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detailTile.vue
// module id = null
// module chunks = 